import {Row} from "antd";
import styled from "styled-components";

export const ActionButtonsContainer = styled(Row)`
    width: 100%;
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;

    margin-bottom: 16px;

    @media (max-width: 576px) {
        margin-top: 16px;
        align-items: center;
        justify-content: flex-start;
    }
`;
